/**
 * Build-time bundle of every Karel world file under `src/worlds/`.
 *
 * Vite inlines the raw text of each `.w` file into the application bundle, so
 * worlds load synchronously and the app works offline without per-world network
 * requests. The source files live in `src/worlds/` for authoring and for the
 * Python tooling (`tools/render_world.py`).
 */
const worldModules = import.meta.glob("../worlds/**/*.w", {
  query: "?raw",
  import: "default",
  eager: true,
}) as Record<string, string>;

/**
 * Normalizes a world glob path or user-supplied name to the bundle key:
 * strips the `../worlds/` prefix and the `.w` extension. Accepts `u5l1`,
 * `worlds/u5l1.w`, and `apcsp/c1l1`.
 */
export function normalizeWorldName(name: string): string {
  return name.replace(/^.*?worlds\//, "").replace(/\.w$/, "");
}

/** World text keyed by world name, e.g. `u5l1` or `u5l1.goal`. */
export const worldTextByName: Record<string, string> = Object.fromEntries(
  Object.entries(worldModules).map(([path, text]) => [
    normalizeWorldName(path),
    text,
  ]),
);
